export enum TicketStatus {
  NEW = "New",
  IN_PROGRESS = "In progress",
  CLOSED = "Closed",
  LOCKED = "Locked",
}
